import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SITE } from "@/config";

const FOOTER_LINKS = [
  { label: "Home", to: "/" },
  { label: "Consulenza", to: "/#consulenza" },
  { label: "Marketing", to: "/#marketing" },
  { label: "BF360", to: "/bf360" },
  { label: "Formazione", to: "/#formazione" },
  { label: "Delta Digital Agency", to: "/delta" },
  { label: "Chi sono", to: "/chi-sono" },
  { label: "Contatti", to: "/contatti" },
];

const CONTACTS = [
  { label: "Instagram", href: SITE.socials.instagram, testid: "social-instagram", external: true },
  { label: "LinkedIn", href: SITE.socials.linkedin, testid: "social-linkedin", external: true },
  { label: SITE.email, href: `mailto:${SITE.email}`, testid: "footer-email", external: false },
  { label: `WhatsApp ${SITE.whatsappLabel}`, href: `https://wa.me/${SITE.whatsapp}`, testid: "footer-whatsapp", external: true },
];

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-ink text-white">
    <div className="mx-auto max-w-[1440px] px-6 py-16 lg:px-12 lg:py-24">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <div className="flex items-center gap-3">
            <img src="/assets/monogram.svg" alt="" aria-hidden="true" className="h-10 w-10" />
            <p className="font-display text-2xl font-bold tracking-tight">{SITE.name}</p>
          </div>
          <p className="mt-4 max-w-sm font-mono text-[11px] uppercase leading-relaxed tracking-[0.22em] text-white/45">
            {SITE.tagline}
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="mb-6 font-mono text-[10px] uppercase tracking-[0.3em] text-white/35">Navigazione</p>
          <ul className="grid grid-cols-2 gap-x-6 gap-y-3">
            {FOOTER_LINKS.map((l) => (
              <li key={l.label}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  className="text-sm text-white/60 transition-colors duration-300 hover:text-white"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <p className="mb-6 font-mono text-[10px] uppercase tracking-[0.3em] text-white/35">Contatti & Social</p>
          <ul className="space-y-3">
            {CONTACTS.map((s) => (
              <li key={s.testid}>
                <a
                  href={s.href}
                  data-testid={s.testid}
                  {...(s.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                  className="group inline-flex items-center gap-2 text-sm text-white/60 transition-colors duration-300 hover:text-white"
                >
                  {s.label}
                  <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-20 select-none overflow-hidden" aria-hidden="true">
        <p className="whitespace-nowrap font-display text-[11.5vw] font-extrabold leading-none tracking-tighter text-accent/[0.07] lg:text-[9vw]">
          {SITE.name}
        </p>
      </div>

      <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/35">
          © {new Date().getFullYear()} {SITE.shortName} — Tutti i diritti riservati
        </p>
        <div className="flex gap-6">
          <Link to="/privacy-policy" data-testid="footer-privacy" className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/35 transition-colors duration-300 hover:text-white">
            Privacy Policy
          </Link>
          <Link to="/cookie-policy" data-testid="footer-cookie" className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/35 transition-colors duration-300 hover:text-white">
            Cookie Policy
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
